const corporateBusinessType = [
    'S.A.',
    'S.A.S',
    'LTDA',
    'Otra',
]

export default corporateBusinessType;